import React, { useState, useEffect, useRef } from "react";

import { BiUser } from "react-icons/bi";
import { PiShoppingCart } from "react-icons/pi";
import { MdOutlineLibraryBooks } from "react-icons/md";
import { IoLocationOutline ,IoHeartOutline} from "react-icons/io5";
import { FaSearch } from "react-icons/fa";
import { Categories } from "../NavComponent/Categories";
import Login from "../Login/Login";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import PincodeModal from "../../PincodeModal"; 
import { useLocation } from "react-router-dom";

const Navbar2 = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDropdownOpens, setIsDropdownOpens] = useState(false);
  const [search, setSearch] = useState("");
  const [navbarColor, setNavbarColor] = useState("#000");
  const [navbarTextColor, setnavbarTextColor] = useState("#fff");
  const [font, setFont] = useState("");
  const [themeColor, setThemeColor] = useState("#708090");
  const [themeIconColor, setThemeIconColor] = useState("#708090");
  const [enabledropdown, setEnableDropdown] = useState(false);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const accessToken = sessionStorage.getItem("accessToken");
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [city, setCity] = useState(" ");
  const [state, setState] = useState(" "); 
  const [wishlistCount, setWishlistCount] = useState(0);
  const [cartCount, setCartCount] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const admin_auto_id = sessionStorage.getItem("admin_auto_id");
  const app_type_id = sessionStorage.getItem("app_type_id");
  const app_logo = sessionStorage.getItem("appLogo");
  const app_name = sessionStorage.getItem("appName") || "Grobiz";
  const [logoAvailable, setLogoAvailable] = useState(false);
  const fullLogoUrl = `https://geobull.in/GrobizEcommerceSuperAdmin/images/admin_logo/${app_logo}`; 
  const [categories, setCategories] = useState([]);
  const [categoryCardNo, setCategoryCardNo] = useState(2);
  const [activeCategory, setActiveCategory] = useState(null);
  const categoriesDropdownRef = useRef(null);

const location = useLocation();

const isActive = (path) => location.pathname === path;



  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/get_main_category_list`,
          { admin_auto_id, app_type_id }
        );
        if (response.data.status === 1) {
          const categoriesData = response.data.getmain_categorylist.map((category) => ({
            id: category.category_auto_id,
            label: category.category_name,
            imgSrc: `https://grobizapp-n.s3.ap-south-1.amazonaws.com/categories/${category.category_image_app}`,
            subcategories: category.getmain_subcategorylist || [],
          }));
          setCategories(categoriesData);
        }
      } catch (err) {
        console.error("Error fetching categories:", err);
      }
    };

    fetchCategories();
  }, [admin_auto_id, app_type_id]);

  useEffect(() => {
    const storedCity = sessionStorage.getItem("userCity");
    const storedState = sessionStorage.getItem("userState");
    if (storedCity) setCity(storedCity);
    if (storedState) setState(storedState);
  }, [showModal]);



  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  
    useEffect(() => {
      if (app_logo) {
        const fullUrl = `https://geobull.in/GrobizEcommerceSuperAdmin/images/admin_logo/${app_logo}`;
        const img = new Image();
        img.src = fullUrl;
  
        img.onload = () => setLogoAvailable(true);
        img.onerror = () => setLogoAvailable(false);
      }
    }, [app_logo]);

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setNavbarColor(parsedStyle.nav_bar_color);
      setnavbarTextColor(parsedStyle.navbar_text_color);
      setFont(parsedStyle.web_font);
      setThemeColor(parsedStyle.web_theme_colour);
      setThemeIconColor(parsedStyle.web_theme_icon_color);
      setEnableDropdown(parsedStyle.enable_navbar_dropdown === "true");
      setShowSearchBar(parsedStyle.show_search_bar === "Yes");
      setCategoryCardNo(parseInt(parsedStyle.categorycard_no));

    }
  }, []);

  const handleProfileClick = () => {
    // If there's an accessToken, navigate to /dashboard
    if (accessToken) {
      navigate("/dashboard");
    }
  };

  const handleInputChange = async (e) => {
    const value = e.target.value;
    setQuery(value);

    if (value.length > 1) {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/search_product`,
          {
            admin_auto_id: admin_auto_id,
            app_type_id: app_type_id,
            customer_auto_id: accessToken || admin_auto_id,
            search: value,
            limit: 15,
            page_number: 1,
          }
        );

        if (response.data.status === 1) {
          setSuggestions(response.data.get_search_products_lists || []);
          setShowDropdown(true);
        } else {
          setSuggestions([]);
          setShowDropdown(false);
        }
      } catch (error) {
        console.error("Search error:", error);
        setSuggestions([]);
        setShowDropdown(false);
      }
    } else {
      setSuggestions([]);
      setShowDropdown(false);
    }
  };

  const goToCart = () => {
    navigate("/cart");
  }; 


   const goToWishlist = () => {
    !accessToken
      ? openModal()
      : navigate("/dashboard", { state: { page: "mywishlist" } });
  }; 


    const fetchWishlistCount = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_wishlist_product_count`,
        {
          admin_auto_id: sessionStorage.getItem("admin_auto_id"),
          user_auto_id: sessionStorage.getItem("accessToken"),
        }
      );
      if (res.data.status === 1) {
        setWishlistCount(res.data.product_count_data);
      } else {
        setWishlistCount(0);
      }
    } catch (error) {
      setWishlistCount(0);
      console.error("Error fetching wishlist count:", error);
    }
  }; 

  useEffect(() => {
  const handleClickOutside = (event) => {
    if (
      isDropdownOpen &&
      categoriesDropdownRef.current &&
      !categoriesDropdownRef.current.contains(event.target)
    ) {
      setIsDropdownOpen(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, [isDropdownOpen]);


  useEffect(() => {
    const handleUserDataUpdated = () => {
      if (accessToken) {
        fetchWishlistCount();
        fetchCartCount();
      } else {
        setWishlistCount(0); // reset when not logged in
        setCartCount(0);
      }
    };

    window.addEventListener("wishlist-updated", handleUserDataUpdated);
    window.addEventListener("cart-updated", handleUserDataUpdated);

    // Initial fetch if logged in
    if (accessToken) {
      fetchWishlistCount();
      fetchCartCount();
    }

    return () => {
      window.removeEventListener("wishlist-updated", handleUserDataUpdated);
      window.removeEventListener("cart-updated", handleUserDataUpdated);
    };
  }, [accessToken]);

  const fetchCartCount = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_cart_product_count`,
        {
          admin_auto_id: sessionStorage.getItem("admin_auto_id"),
          user_auto_id: sessionStorage.getItem("accessToken"),
        }
      );
      if (res.data.status === 1) {
        setCartCount(res.data.product_count_data);
      } else {
        setCartCount(0);
      }
    } catch (error) {
      setCartCount(0);
      console.error("Error fetching cart count:", error);
    }
  };



  return (
    <nav
      className={` shadow-md w-full ${font}`}
      style={{ backgroundColor: navbarColor }}
    >
<div className="w-full mx-auto px-0 py-3 flex justify-between items-center flex-wrap 
                sm:px-4 md:px-6 lg:max-w-[2000px]">
        
        <div className="container flex flex-wrap items-center justify-between px-4 py-3 mx-auto">
          {/* ✅ Mobile Header (Hamburger + Logo + Icons) */}
          <div className="flex items-center justify-between w-full md:hidden">
            {/* Left - Hamburger */}
            <button 
              onClick={() => setIsDropdownOpen(!isDropdownOpen)} 
              className="text-2xl"
              style={{ color: navbarTextColor }}
            >
              ☰
            </button>

          {/* Left-aligned Logo */}
<Link
  to="/"
  className="flex justify-start items-center w-[70%] no-underline"
>
  {logoAvailable ? (
    <img
      src={fullLogoUrl}
      alt="App Logo"
      className="w-auto h-16 ml-4"
    />
  ) : (
    <span
      className="text-lg font-bold"
      style={{ color: navbarTextColor }}
    >
      {app_name}
    </span>
  )}
</Link>


            {/* Right - Icons */}
<div className="flex items-center space-x-4">
  <button onClick={accessToken ? handleProfileClick : openModal}>
    <BiUser className="text-2xl" style={{ color: themeIconColor }} />
  </button>

  <button onClick={goToCart} className="relative">
    <PiShoppingCart className="text-2xl" style={{ color: themeIconColor }} />
    {cartCount > 0 && (
      <span className="absolute -top-1 -right-2 bg-red-500 text-white text-[10px] px-1 rounded-full">
        {cartCount}
      </span>
    )}
  </button>

  <button onClick={goToWishlist} className="relative">
    <IoHeartOutline className="text-2xl" style={{ color: themeIconColor }} />
    {wishlistCount > 0 && (
      <span className="absolute -top-1 -right-2 bg-red-500 text-white text-[10px] px-1 rounded-full">
        {wishlistCount}
      </span>
    )}
  </button>
</div>

          </div>

          {/* ✅ Desktop layout (your existing code below this remains same) */}
          {/* ✅ Desktop Logo (Hidden on Mobile) */}
          <div className="hidden md:flex">
            <Link
              className="no-underline cursor-pointer textt-inherit decoration-none"
              to={"/"}
            >
              <div
                className="flex items-center space-x-4 text-2xl font-bold text-gray-800"
                style={{ color: navbarTextColor }}
              >
                {app_logo ? (
                  <img
                    src={`https://geobull.in/GrobizEcommerceSuperAdmin/images/admin_logo/${app_logo}`}
                    alt="App Logo"
                    className="w-auto h-16"
                  />
                ) : (
                  app_name || "Grobiz"
                )}
              </div>
              {/* <span className="text-3xl font-bold text-black">Grobiz</span> */}
            </Link>
          </div>

          {/* Location */}
        <div className="relative">
          {/* Location Button */}
          <div className="z-50 items-center hidden space-x-2 md:flex">
            {/* Location Button */}
            <button
              onClick={() => setShowModal(true)}
             
              className="flex items-center text-gray-800"
            >
              <IoLocationOutline
                className="mr-1 text-lg"
                style={{ color: themeIconColor }}
              />
              <span className="font-medium" style={{ color: navbarTextColor }}>
                {city}
              </span>
            </button>

            {/* Location Text */}
            <span
              className="text-xs text-gray-600"
              style={{ color: navbarTextColor }}
            >
              {state}, India
            </span>
          </div>

          {/* Dropdown with Search Bar */}
          {enabledropdown && isDropdownOpens && (
            <div className="absolute z-20 p-3 mt-2 bg-white rounded-md shadow-lg top-full w-96">
              <div className="relative">
                <input
                  type="text"
                  placeholder="Search location..."
                  className="w-full px-4 py-2 pr-10 border border-gray-300 rounded-xl"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
                <FaSearch className="absolute text-gray-600 right-3 top-3" />
              </div>

              {/* Example Locations (Replace with API results if needed) */}
              <ul className="mt-3 space-y-2">
                <li
                  className="p-2 rounded cursor-pointer hover:bg-gray-200"
                  onClick={() => setSearch("Mumbai")}
                >
                  Mumbai, Maharashtra
                </li>
                <li
                  className="p-2 rounded cursor-pointer hover:bg-gray-200"
                  onClick={() => setSearch("Delhi")}
                >
                  Delhi, India
                </li>
                <li
                  className="p-2 rounded cursor-pointer hover:bg-gray-200"
                  onClick={() => setSearch("Bangalore")}
                >
                  Bangalore, Karnataka
                </li>
              </ul>
            </div>
          )}
        </div>

        <div className="flex items-center w-full md:max-w-[500px] lg:max-w-[600px] mt-2 md:mt-0 relative">

  <FaSearch className="absolute text-sm text-gray-600 left-3" />

  <input
    type="text"
    placeholder="Search for products, brands and more"
    className="w-full py-2 pl-10 pr-3 text-sm transition border border-gray-300 rounded-lg shadow-sm outline-none focus:ring-2 focus:ring-blue-400"
    value={query}
    onChange={handleInputChange}
  />

  {showDropdown && suggestions.length > 0 && (
    <ul className="absolute left-0 z-50 w-full mt-2 overflow-y-auto bg-white border rounded-lg shadow-xl top-full max-h-60">
      {suggestions.map((item, index) => (
        <Link
          to={`/product-detail/${item.product_auto_id}`}
          className="no-underline text-inherit"
        >
         <li
  key={index}
  className="flex items-center gap-3 px-4 py-2 text-sm text-black transition rounded-md cursor-pointer hover:bg-gray-100"
  onClick={() => {
    setQuery(item.product_name);
    setShowDropdown(false);
  }}
>
  <img
    src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${item.product_images[0]?.product_image}`}
    alt={item.product_name}
    className="object-cover w-8 h-8 border rounded-md"
  />

  <div>
    <div className="font-medium">{item.product_name}</div>

    {/* ✅ Brand name */}
    {item.brand_name && (
      <div className="text-xs text-gray-500">
        Brand: {item.brand_name}
      </div>
    )}
  </div>
</li>

        </Link>
      ))}
    </ul>
  )}
</div>



        {/* Categories Dropdown */}
        {enabledropdown &&  (
        <div 
        ref={categoriesDropdownRef}
        className="relative z-50 items-center hidden md:flex">
          <button
  onClick={(e) => {
    e.stopPropagation();   // ⛔ prevent instant close
    toggleDropdown();
  }}
  className={`flex items-center transition-colors duration-200 
    ${
      isDropdownOpen
        ? "text-[color:var(--opencolor)]"
        : "text-[color:var(--closecolor)]"
    }`}
  style={{
    "--opencolor": navbarTextColor,
    "--closecolor": navbarTextColor,
  }}
>
  <MdOutlineLibraryBooks
    className="m-2"
    style={{ color: themeIconColor }}
  />
  Categories
</button>

        {enabledropdown && isDropdownOpen && (
  <div
    className="right-5"
    onClick={(e) => e.stopPropagation()} // ⛔ keep open on inside click
  >
    <Categories
      categories={categories}
      themeColor={themeColor}
      navbarTextColor={navbarTextColor}
      categoryCardNo={categoryCardNo}
    />
  </div>
)}

        </div>
        )}


        {/* Login and Cart */}
        <div className="items-center justify-between hidden mt-2 space-x-4 md:flex md:mt-0">

          <button
            className="flex items-center text-gray-800"
            style={{ color: navbarTextColor }}
            onClick={accessToken ? handleProfileClick : openModal}
          >
            <BiUser className="m-2" style={{ color: themeIconColor }} />
            {accessToken ? "Profile" : "Login"}
          </button>
          <button
            className="flex items-center "
            style={{ color: navbarTextColor }}
            onClick={goToCart}
          >
            <div className="relative">
            <PiShoppingCart className="m-2" style={{ color: themeIconColor }} />
            { cartCount> 0 && (
                <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] sm:text-xs px-1 sm:px-1.5 py-0.5 rounded-full">
                  {cartCount}
                </span>
              )}
            
            </div>
            <span className="ml-1">Cart</span>
          </button> 
          <button
            className="relative flex items-center"
            style={{ color: navbarTextColor }}
            onClick={goToWishlist}
          >
            <div className="relative">
              <IoHeartOutline
                className="m-2 text-xl" 
                style={{ color: themeIconColor }}
              />
              {wishlistCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] sm:text-xs px-1 sm:px-1.5 py-0.5 rounded-full">
                  {wishlistCount}
                </span>
              )}
            </div>
            <span className="ml-1">Wishlist</span>
          </button>


        </div>
        </div>



        
      </div>
      {isOpen && <Login isOpen={isOpen} onClose={closeModal} />}
      <PincodeModal showModal={showModal} setShowModal={setShowModal} />

          
 {/*  Bottom Navigation Bar for Mobile */}
<div className="md:hidden fixed bottom-0 left-0 w-full bg-white  flex justify-between items-center py-0 sm:py-3 z-[999]">

  {/* Home */}
  <button
    onClick={() => navigate('/')}
    className={`flex flex-1 flex-col items-center py-2 transition ${
      isActive('/')
        ? "bg-gradient-to-b from-orange-200 to-white text-orange-600"
        : "bg-transparent text-gray-700"
    }`}
  >
    <MdOutlineLibraryBooks
      className={`text-2xl font-semibold drop-shadow-sm transition ${
        isActive('/') ? "text-orange-600" : "text-gray-700"
      }`}
    />
    <span className="text-[11px]">Home</span>
  </button>

  {/* Category */}
  <button
    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
    className={`flex flex-1 flex-col items-center py-2 transition ${
      isActive('/categories')
        ? "bg-gradient-to-b from-orange-200 to-white text-orange-600"
        : "bg-transparent text-gray-700"
    }`}
  >
    <MdOutlineLibraryBooks
      className={`text-2xl font-semibold drop-shadow-sm transition ${
        isActive('/categories') ? "text-orange-600" : "text-gray-700"
      }`}
    />
    <span className="text-[11px]">Category</span>
  </button>

  {/* Cart */}
  <button
    onClick={goToCart}
    className={`flex flex-1 flex-col items-center relative py-2 transition ${
      isActive('/cart')
        ? "bg-gradient-to-b from-orange-200 to-white text-orange-600"
        : "bg-transparent text-gray-700"
    }`}
  >
    <PiShoppingCart
      className={`text-2xl font-semibold drop-shadow-sm transition ${
        isActive('/cart') ? "text-orange-600" : "text-gray-700"
      }`}
    />

    {cartCount > 0 && (
      <span className="absolute -top-1 right-3 bg-red-500 text-white text-[9px] px-1 rounded-full">
        {cartCount}
      </span>
    )}
    <span className="text-[11px]">Cart</span>
  </button>

  {/* Wishlist */}
  <button
    onClick={goToWishlist}
    className={`flex flex-1 flex-col items-center relative py-2 transition ${
      location.state?.page === "mywishlist"
        ? "bg-gradient-to-b from-orange-200 to-white text-orange-600"
        : "bg-transparent text-gray-700"
    }`}
  >
    <IoHeartOutline
      className={`text-2xl font-semibold drop-shadow-sm transition ${
        location.state?.page === "mywishlist"
          ? "text-orange-600"
          : "text-gray-700"
      }`}
    />

    {wishlistCount > 0 && (
      <span className="absolute -top-1 right-3 bg-red-500 text-white text-[9px] px-1 rounded-full">
        {wishlistCount}
      </span>
    )}
    <span className="text-[11px]">Wishlist</span>
  </button>

  {/* Profile */}
  <button
    onClick={accessToken ? handleProfileClick : openModal}
    className={`flex flex-1 flex-col items-center py-2 transition ${
      isActive('/dashboard')
        ? "bg-gradient-to-b from-orange-200 to-white text-orange-600"
        : "bg-transparent text-gray-700"
    }`}
  >
    <BiUser
      className={`text-2xl font-semibold drop-shadow-sm transition ${
        isActive('/dashboard') ? "text-orange-600" : "text-gray-700"
      }`}
    />
    <span className="text-[11px]">{accessToken ? "Profile" : "Login"}</span>
  </button>

</div>








         
        {/* ✅ Mobile Slider Menu */}
        <div
          className={`fixed top-0 left-0 w-72 h-full bg-white shadow-2xl z-[999]
          transform transition-transform duration-300 ease-in-out md:hidden
          ${isDropdownOpen ? "translate-x-0" : "-translate-x-full"}`}
        >
          <div className="flex items-center justify-center h-16">
          <span className="font-bold">Categories</span>
        </div>

        {/* Header */}
        <div className="p-4 bg-[var(--opencolor)] text-white text-lg font-semibold flex justify-between items-center">
          <span className="flex items-center">
            {activeCategory ? (
              <button
                onClick={() => setActiveCategory(null)}
                className="mr-2 text-2xl"
              >
                ←
              </button>
            ) : null}
            {activeCategory ? activeCategory.label : "Categories"}
          </span>

          <button
            onClick={() => {
              if (activeCategory) {
                setActiveCategory(null);
              } else {
                setIsDropdownOpen(false);
              }
            }}
            className="text-xl"
          >
            ✕
          </button>
        </div>

        {/* ✅ Main Category List */}
        <ul
          className={`overflow-y-auto h-[85vh] p-2 absolute top-[56px] left-0 w-full
          transition-transform duration-300 ease-in-out
          ${activeCategory ? "-translate-x-full" : "translate-x-0"}`}
        >
          
          {categories.map((cat) => (
            <li key={cat.id} className="mb-1">
              <div
                className="flex items-center justify-between px-3 py-2 bg-gray-100 rounded-lg cursor-pointer hover:bg-gray-200"
                onClick={() => setActiveCategory(cat)}
              >
                <div className="flex items-center gap-3">
                  <img
                    src={cat.imgSrc}
                    alt={cat.label}
                    className="object-cover w-8 h-8 rounded-md"
                  />
                  <span className="text-sm font-medium text-gray-800">
                    {cat.label}
                  </span>
                </div>
                <span className="text-gray-600">›</span>
              </div>
            </li>
          ))}
        </ul>

        {/* ✅ Subcategory List (Slides In with Back Arrow) */}
      {activeCategory && (
        <div
          className={`overflow-y-auto h-full absolute top-0 left-0 w-full bg-white
          transition-transform duration-300 ease-in-out
          ${activeCategory ? "translate-x-0" : "translate-x-full"}`}
        >
          {/* 🔙 Header with Back Arrow */}
          <div className="flex items-center px-4 py-3 font-semibold text-gray-800 border-b">
            <button
              onClick={() => setActiveCategory(null)}
              className="mr-3 text-xl"
            >
              ←
            </button>
            <span className="text-sm tracking-wide uppercase">
              {activeCategory.label}
            </span>
          </div>

          {/* 🧩 Subcategory List */}
      <ul className="p-2">
        {activeCategory.subcategories?.map((sub) => (
          <li key={sub.sub_category_auto_id} className="mb-1">
            <div
              className="flex items-center justify-between px-3 py-2 bg-gray-100 rounded-lg cursor-pointer hover:bg-gray-200"
              onClick={() => {
                navigate("/productlist", {
                  state: {
                    subcategoryName: sub.sub_category_name,
                    sub_cat_id: sub.sub_category_auto_id,
                  },
                });
                setIsDropdownOpen(false);
              }}
            >
              <div className="flex items-center gap-3">
                <img
                  src={
                    sub.subcategory_image_app
                      ? `https://grobizapp-n.s3.ap-south-1.amazonaws.com/subcategories/${sub.subcategory_image_app}`
                      : "/default-image.png"
                  }
                  alt={sub.sub_category_name}
                  className="object-cover w-8 h-8 rounded-md"
                />
                <span className="text-sm font-medium text-gray-800">
                  {sub.sub_category_name}
                </span>
              </div>
              <span className="text-gray-600">›</span>
            </div>
          </li>
        ))}
      </ul>


        </div>
      )}

      </div>

      {/* Dim Background */}
      {isDropdownOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-[998] md:hidden"
          onClick={() => setIsDropdownOpen(false)}
        ></div>
      )}
      

    </nav>
    
  );
  
};

export default Navbar2;
